import React from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import RegularWritebackFlagMaintenance from "./RegularWritebackFlagMaintenance";
import ReasonCodeMaintenance from "./ReasonCodeMaintenance";


const SSAControl = () => {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box sx={{ width: "100%", px: 2, py: 1, display: "flex", flexDirection: "column", flex: 1 }}>
      <Typography sx={{ fontSize: 20, fontWeight: 600, mb: 2 }}>
        SSA Control
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, value: number) => setActiveTab(value)}
        variant="fullWidth"
        textColor="inherit"
        TabIndicatorProps={{ style: { backgroundColor: "#000", height: 2 } }}
        sx={{
          mb: 2,
          borderBottom: "1px solid #d9d9d9",
          "& .MuiTab-root": {
            color: "#333",
            textTransform: "none",
            fontWeight: 500,
            minHeight: 44,
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#000",
            fontWeight: 600,
          },
          "& .MuiTab-root.Mui-focusVisible": {
            outline: "1px solid #000",
            outlineOffset: -1,
          },
        }}
      >
        <Tab sx={{ flex: 1, minWidth: 0 }} label="Regular Writeback Flag Maintenance" />
        <Tab sx={{ flex: 1, minWidth: 0 }} label="Reason Code Maintenance" />
      </Tabs>

      {activeTab === 0 && <RegularWritebackFlagMaintenance />}
      {activeTab === 1 && <ReasonCodeMaintenance />}
    </Box>
  );
};

export default SSAControl;
